import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Styles from './style.css';

export default function FileList({ files, onDelete }) {
    return (
        <div className={Styles.fileList}>
            {(files ?? []).map((file, idx) => {
                return (
                    <div key={file.name} className={Styles.uploadedFile}>
                        <div>{file.name}</div>
                        <span className={Styles.closeIcon}>
                            <FontAwesomeIcon icon={faClose} onClick={() => onDelete(file, idx)} />
                        </span>
                    </div>
                );
            })}
        </div>
    );
}
